import { GET_STEPS, ADD_STEPS, GET_STEP_REG,UPDATE_STEPS ,DRAGUPDATE_STEPS,GET_STEPS_PROCEDURE} from '../types'

const INITIAL_STATE = {
  allSteps: [],
  dragUpdateSteps:[],
  getAllNewSteps:[]
  
}

const stepReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_STEP_REG:
      return {
        ...state,
        loader:true
      }
    case GET_STEPS:
      return {
        ...state,
        allSteps: payload.data,
        loader:false
      }
      

      case GET_STEPS_PROCEDURE:
        return {
          ...state,
          getAllNewSteps: payload.data,
          loader:false
        }
    case ADD_STEPS:
      return {
        ...state,
        addSteps: payload,
      }

    case UPDATE_STEPS:
      return {
        ...state,
        updateSteps: payload.data,
        loader: false,
      }

      case DRAGUPDATE_STEPS:
        return {
          ...state,
          dragUpdateSteps: payload.data,
          }

    default:
      return state
  }
}

export default stepReducer
